/**
 *  自由节点
 *  不生成多余节点
 * Author:   FJJ
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2022-08-12           1.0     First version
 *
 * Copyright 2022, all rights reserved. Essa.cn
 * */

import React from "react";
export default class LoadFree extends React.Component {
    static defaultProps = {
        children:<span></span>

    };
    componentDidMount() {
      if(this.props.onNodeload)this.props.onNodeload()
    }
    render() {
        const {
            children
        } = this.props;
        return (children)
    }
}
